export default "__VITE_ASSET__D3u$jszd__"